"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  PORTAL: 'portalTz',
  USER: 'userTz',
  UTC: 'utc'
};
exports.default = _default;
module.exports = exports.default;